import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPurchaseConfirmationDialog = loadable(() => import(/* webpackChunkName: "content/guest/registry/purchaseconfirmationdialog" */ './PurchaseConfirmationDialog'));
